import webdevelopmentimgone from "../assets/webdevelpment/webdevlopmentimgone.jpeg";
import webdevelopmentimgtwo from "../assets/webdevelpment/webdevelopmentimgtwo.jpeg";
import webdevelopmentimgthree from "../assets/webdevelpment/webdevelopmentimgthree.jpeg";

const WebdevelopmentPageData = [
  {
    icon: webdevelopmentimgone,
    // path: "Web-Development",
  },

  {
    icon: webdevelopmentimgtwo,
    // path:"Digital-Marketing"
  },

  {
    icon: webdevelopmentimgthree,
    // path:"Web-Services"
  },
];

export default WebdevelopmentPageData;
